import React from "react";
import { PlannedHarvests } from "../modules/PlannedHarvests";

export function PlannedHarvestCardPage(props) {
  return <PlannedHarvests {...props} />;
}
